import createIcon from './createIcon';
import HomeOutlinedSvg from './svg/home-outlined.svg?react';

const HomeOutlinedIcon = createIcon(HomeOutlinedSvg);

export default HomeOutlinedIcon;
